import createReducer from 'utils/createReducer';

const DEFAULT_VAT = 21;
const DEFAULT_CURRENCY = 'EUR';

// Initial State
const INIT_STATE = {
  initialShipperOrder: null,
  shipperUsers: [],
  shipperAddresses: [],
  mainLoading: true,
  submiting: false,
  userInfo: {
    zipcodeRE: null,
    country: null,
    vat: DEFAULT_VAT,
    currency: DEFAULT_CURRENCY,
  },
  quote: {
    ready: false,
    loading: false,
  },
  quoteRedeemError: false,
};

// Actions
const SET_SHIPPER_USERS = 'shipper-order-form/SET_SHIPPER_USERS';
const SET_SHIPPER_ADDRESSES = 'shipper-order-form/SET_SHIPPER_ADDRESSES';
const APPEND_SHIPPER_ADDRESSES = 'shipper-order-form/APPEND_SHIPPER_ADDRESSES';
const SET_MAIN_LOADING = 'shipper-order-form/SET_MAIN_LOADING';
const SET_USER_INFO = 'shipper-order-form/SET_USER_INFO';
const SET_INITIAL_SHIPPER_ORDER = 'shipper-order-form/SET_INITIAL_SHIPPER_ORDER';
const SET_QUOTE = 'shipper-order-form/SET_QUOTE';
const SET_QUOTE_READY = 'shipper-order-form/SET_QUOTE_READY';
const SET_QUOTE_LOADING = 'shipper-order-form/SET_QUOTE_LOADING';
const SET_SUBMITING = 'shipper-order-form/SET_SUBMITING';
const SET_RESET = 'shipper-order-form/SET_RESET';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_SHIPPER_USERS](state, payload) {
    return {
      ...state,
      shipperUsers: payload,
    };
  },
  [SET_SHIPPER_ADDRESSES](state, payload) {
    return {
      ...state,
      shipperAddresses: payload,
    };
  },
  [APPEND_SHIPPER_ADDRESSES](state, payload) {
    return {
      ...state,
      shipperAddresses: [...payload, ...state.shipperAddresses],
    };
  },
  [SET_MAIN_LOADING](state, payload) {
    return {
      ...state,
      mainLoading: payload,
    };
  },
  [SET_INITIAL_SHIPPER_ORDER](state, payload) {
    return {
      ...state,
      initialShipperOrder: payload,
    };
  },
  [SET_USER_INFO](state, payload) {
    return {
      ...state,
      userInfo: {
        ...state.userInfo,
        ...payload,
      },
    };
  },
  [SET_QUOTE](state, payload) {
    return {
      ...state,
      quote: {
        ...state.quote,
        ...payload,
      },
    };
  },
  [SET_QUOTE_LOADING](state, payload) {
    return {
      ...state,
      quote: {
        ...state.quote,
        loading: payload,
      },
    };
  },
  [SET_QUOTE_READY](state, payload) {
    return {
      ...state,
      quote: {
        ...state.quote,
        ready: payload,
      },
    };
  },
  [SET_SUBMITING](state, payload) {
    return {
      ...state,
      submiting: payload,
    };
  },
  [SET_RESET](state) {
    const { shipperUsers, shipperAddresses, userInfo, quote } = INIT_STATE;

    return {
      ...state,
      shipperUsers,
      shipperAddresses,
      userInfo,
      quote,
    };
  },
});

// Action creators
export const setShipperUsers = (payload) => ({
  type: SET_SHIPPER_USERS,
  payload: payload,
});

export const setShipperAddresses = (payload) => ({
  type: SET_SHIPPER_ADDRESSES,
  payload: payload,
});

export const appendShipperAddresses = (payload) => ({
  type: APPEND_SHIPPER_ADDRESSES,
  payload: payload,
});

export const setMainLoading = (payload) => ({
  type: SET_MAIN_LOADING,
  payload: payload,
});

export const setInitialShipperOrder = (payload) => ({
  type: SET_INITIAL_SHIPPER_ORDER,
  payload: payload,
});

export const setQuote = (payload) => ({
  type: SET_QUOTE,
  payload: payload,
});

export const setQuoteLoading = (payload) => ({
  type: SET_QUOTE_LOADING,
  payload: payload,
});

export const setQuoteReady = (payload) => ({
  type: SET_QUOTE_READY,
  payload: payload,
});

export const setSubmiting = (payload) => ({
  type: SET_SUBMITING,
  payload: payload,
});

export const setReset = (payload) => ({
  type: SET_RESET,
  payload: payload,
});

export const setUserInfo = ({ zipcodeRE, country, vat, currency }) => ({
  type: SET_USER_INFO,
  payload: {
    zipcodeRE,
    country,
    vat,
    currency,
  },
});
